import gql from "graphql-tag"
import SourceAssetFragment from "../fragment/SourceAssetFragment"

export default gql`
  ${SourceAssetFragment}
  mutation sourceAssetRetry($id: String!) {
    sourceAssetRetry(id: $id) {
      ...SourceAssetFragment
    }
  }
`
